"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mongoliaTranslations = void 0;
var _types = require("../../../types");
const mongoliaTranslations = exports.mongoliaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Уучлаарай!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Буцах',
  [_types.ErrorPageTranslationKey.text]: 'Энэхүү хуудас одоогоор ажиллах боломжгүй байна',
  [_types.ErrorPageTranslationKey.notFound]: 'Хуудас олдсонгүй',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Энэ хуудас рүү хандах боломжгүй байна, та бүх шаардлагыг хангахгүй байна.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Орифлэймийн тусламжийн багтай имэйлээр холбогдоно уу:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Хүссэн URL татгалзсан!'
};
